import React from 'react';

const SvgDropdown = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 10 6" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 1.243L8.694 0l-.65.625L5 3.515 1.955.625 1.305 0 0 1.243l.657.617 3.037 2.897L5 6l1.306-1.243L9.343 1.86z"
    />
  </svg>
);

export default SvgDropdown;
